var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotconfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 274.338,
    height: 283.52,
    viewBox: "0 0 274.338 283.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b,.t{fill:#333;}.c{fill:#eabfa5;}.d{fill:#d84744;}.e{fill:#822a2a;}.f{fill:#eef9f9;}.g{fill:#ffabab;}.h{fill:#d8a98f;}.i{fill:#f7cab2;}.j{fill:#e5a920;}.k{fill:#c68d1a;}.l{fill:#efb135;}.m{fill:#fcc34f;}.n{fill:#846c5d;}.o{fill:#3ac1b0;}.p{fill:#4addc7;}.q{fill:#39aa99;}.r{fill:#db7631;}.s{fill:#b64e00;}.t{opacity:0.2;}.u{opacity:0.3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1.217,
    x2: 0.5,
    y2: 0.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#3ac1b0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.388 -6.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.262 6.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.465)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M244.588,150.259h-8.535l-14.728-144h37.991Z",
    transform: "translate(-221.325 -6.262)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.656 30.754)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.84 70.285)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M265.255,153.2s3.19-5.7,7.176-3.257c6.487,3.975,4.416,12.917,4.416,12.917l-1.49-3.975s1.987,6.293-1.159,10.6l.331-4.14s-2.484,5.962-6.956,6.624-5.134.662-5.631,3.312,3.139,4.411,1.987,4.223c-4.057-.662-3.643-5.8-3.643-5.8l-.662,3.726s-5.134-9.937-4.8-14.574a17.126,17.126,0,0,1,2.484-7.784l-2.65.994S262.605,143.431,265.255,153.2Z",
    transform: "translate(-242.345 -149.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M262.9,169.691c2.126-3.841,5.36-8.13-2.2-12.1-1.218-.64-4.1-.144-5.244-.193-.8-.034-.891.809-1.606.917a13.4,13.4,0,0,0-8.169,4.876s4.783,7.317-9.443,16.6c-1.662,1.085,10.21,19.678,11.379,12.794C251.584,169.179,261.618,172,262.9,169.691Z",
    transform: "translate(-236.072 -152.01)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.062 4.943)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.573 2.878)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M256.974,161.19s2.319-.635,4.9,2.746a.6.6,0,0,1-.284.947,8.78,8.78,0,0,1-5.055.088C253.172,163.805,256.974,161.19,256.974,161.19Z",
    transform: "translate(-255.146 -161.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M262.964,166.5c.016,0,.024-.017.039-.023a2.841,2.841,0,0,0-1.671-.538,2.764,2.764,0,0,0-2.109.937A9.969,9.969,0,0,0,262.964,166.5Z",
    transform: "translate(-256.522 -162.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M261.91,164.491s-2.264-2.208-4.693-2.429c0,0,2.209.635-.11.718,0,0-.662-.331-.331-.884a5.556,5.556,0,0,1,.664-.551.721.721,0,0,1,.513-.148A4.473,4.473,0,0,1,261.91,164.491Z",
    transform: "translate(-255.665 -161.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.585,165.834c-.005,0-.011.014-.017.019a2.842,2.842,0,0,0,1.107.629,6.106,6.106,0,0,0,1.3.286l.011-.023s.373-.331-.083-.745A2.494,2.494,0,0,0,255.585,165.834Z",
    transform: "translate(-255.288 -162.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M257.174,166.823a7.287,7.287,0,0,0,3.129.285,4.465,4.465,0,0,0-2.066-.478,4.945,4.945,0,0,0-1.19.144C257.09,166.791,257.129,166.808,257.174,166.823Z",
    transform: "translate(-255.787 -162.995)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M248.455,173.685c.561,5.435-2.5,17.392-3.232,20.135.1.115.193.231.289.342l6.135-3.209c2.793-11.592,7.3-14.966,10.542-16.413-1.233-.565-2.5-1.163-3.762-1.785-7.618-3.754-9.664-6.544-9.664-6.544S250.682,169.159,248.455,173.685Z",
    transform: "translate(-245.223 -159.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M274.723,174.319s1.6.386.386,2.042-4.968,1.711-4.03-.386S274.723,174.319,274.723,174.319Z",
    transform: "translate(-253.901 -162.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M269.156,161.866s3.147-1.49,4.057,2.484A3.823,3.823,0,0,0,269.156,161.866Z",
    transform: "translate(-253.302 -158.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M271.156,160.428s4.416-1.159,3.975,2.926A3.845,3.845,0,0,0,271.156,160.428Z",
    transform: "translate(-253.977 -157.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M264.614,157.183s2.484.111,2.631,1.49C267.245,158.674,267.623,155.776,264.614,157.183Z",
    transform: "translate(-251.769 -156.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M265.38,159.733s.34-1.806-2.807-.7C262.573,159.032,264.587,158.673,265.38,159.733Z",
    transform: "translate(-251.08 -157.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M263.7,159.991l-.521-.484s.232-.592,1.64-.054a3.692,3.692,0,0,0,2.36.207l-2.567,1.863Z",
    transform: "translate(-251.285 -157.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M261.968,160.269l.8-.692a.58.58,0,0,1,.937.28l.5,1.736A4.145,4.145,0,0,0,261.968,160.269Z",
    transform: "translate(-250.876 -157.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M275.186,175.443s.248,1.532-1.9,1.532c0,0,1.035-.455.828-.869s-.787-.373-.787-.373,1.076-.083,1.159.166a1.567,1.567,0,0,1,.042.58Z",
    transform: "translate(-254.694 -163.092)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M272.031,171.593s3.312-.414,3.643-2.733a6.361,6.361,0,0,0,2.346-1.408c1.027-.975-1.767,5.382-1.767,5.382s-.662-1.159-3.643.166Z",
    transform: "translate(-248.21 -155.418)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.763)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.869)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M269.548,52.527c.838,1.634,3.212,1.3,4.809.123a4.683,4.683,0,0,0,1.708-4.656c-.679-4.167-5.555-6-10.1-3.862-5.808,2.727-7.242,8.306-7.4,13.261-.079,2.434.976,6.885-2.739,8.011-2.346.711-3.527-1.219-4.034-2.774-.341-1.044-.294-2.618,1.363-3.048,1.6-.415,2.738,1.418.741,1.376q.146.864.293,1.729l.347-.179c1.3-.665.137-2.2-1.155-1.54l-.347.178a.905.905,0,0,0,.292,1.729c1.557.033,3.622-.378,4.1-1.985.446-1.514-1.045-2.945-2.583-3.252a4.953,4.953,0,0,0-4.843,2.039c-1.24,1.822-.487,3.91.509,5.472a4.619,4.619,0,0,0,4.966,2.276,6.248,6.248,0,0,0,4.791-3.522c.94-2.168.482-4.551.55-6.732.093-2.961.463-6.289,2.752-8.869,2.111-2.379,6.228-4.458,8.955-2.266a3.926,3.926,0,0,1,1.394,3.043,2.875,2.875,0,0,1-.392,1.618c-.155.228-1.68,1.35-1.806,1.1-.551-1.074-2.719-.364-2.161.725Z",
    transform: "translate(-249.344 -43.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M289.064,78.137l-3.754-11.2-1.2-3.578-3.754-11.2a1.545,1.545,0,0,0-2.881.966l.045.133h0a12.748,12.748,0,0,0-6.584,4.857,13.774,13.774,0,0,0-2.2,5.4,8.6,8.6,0,0,1-5.939,6.521l-.206.069a9.251,9.251,0,0,1-6.228-.052l-2.145-.833a4.531,4.531,0,0,0-3.048-.026l1.567,4.676,1.2,3.578,1.567,4.675a4.527,4.527,0,0,0,2.417-1.857l1.21-1.957a9.255,9.255,0,0,1,4.938-3.8l.206-.07a8.6,8.6,0,0,1,8.669,1.624,13.779,13.779,0,0,0,5.01,2.987,12.751,12.751,0,0,0,8.181-.093h0l.044.133a1.545,1.545,0,0,0,2.881-.965Z",
    transform: "translate(-249.961 -45.975)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.212 5.377)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M268.8,68.609c1.1-1.114,2.962-3.661,4.019-4.875a15.22,15.22,0,0,1,5.9-3.957c.288-.113,7.191,19.5,7.487,19.4L279.6,59.458l-.034-.1c-.168-.5.341-1.122,1.137-1.388s1.577-.078,1.744.423l-2.089-6.23a1.545,1.545,0,0,0-2.881.966l.045.133h0a12.748,12.748,0,0,0-6.584,4.857,13.774,13.774,0,0,0-2.2,5.4,8.6,8.6,0,0,1-5.939,6.521l-.206.069a9.251,9.251,0,0,1-6.228-.052l-2.145-.833a4.531,4.531,0,0,0-3.048-.026l1.555,4.639a38.736,38.736,0,0,1,4.8-.817S266.987,70.452,268.8,68.609Z",
    transform: "translate(-251.173 -51.352)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.27 31.634)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M281.638,95.181c-.317-1.809,1.782-2.97,3.763-3a4.684,4.684,0,0,1,4.169,2.686c1.969,3.735-.819,8.133-5.732,9.169-6.278,1.324-10.784-2.263-13.9-6.12-1.53-1.895-3.371-6.082-7.015-4.742-2.3.847-2.079,3.1-1.547,4.645.358,1.039,1.343,2.266,2.925,1.611,1.524-.632,1.33-2.782-.238-1.545l-.809-1.555.385-.068c1.435-.25,1.438,1.676.007,1.926l-.385.067a.905.905,0,0,1-.809-1.555c1.223-.965,3.117-1.881,4.464-.884,1.269.939.942,2.98-.1,4.151a4.952,4.952,0,0,1-5.093,1.292c-2.088-.707-2.745-2.827-2.892-4.674a4.618,4.618,0,0,1,2.59-4.809,6.245,6.245,0,0,1,5.945-.077c2.057,1.163,3.127,3.341,4.5,5.04,1.858,2.306,4.159,4.739,7.541,5.418,3.118.626,7.656-.2,8.51-3.589a3.928,3.928,0,0,0-.722-3.268,2.866,2.866,0,0,0-1.287-1.055c-.262-.089-2.154-.064-2.107.207.209,1.189-1.95,1.928-2.16.724Z",
    transform: "translate(-258.809 -90.988)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M287.882,70.414a1.134,1.134,0,0,0,.821-.493,1.17,1.17,0,0,0,.236-.571.515.515,0,0,0-.051-.267l-.014-.024-.008-.013h0a3.588,3.588,0,0,0-2.089-1.339.519.519,0,0,0-.125-.3l-.026-.028a2.906,2.906,0,0,0-2.144-.494.494.494,0,0,0-.15-.174.473.473,0,0,0-.072-.045,2.512,2.512,0,0,0-2.052.323.517.517,0,0,0-.214-.1.313.313,0,0,0-.046,0h-.023A2.49,2.49,0,0,0,280.171,68a.5.5,0,0,0-.158-.013.305.305,0,0,0-.056.01.465.465,0,0,0-.083.023l0,.005a2.817,2.817,0,0,0-1.275,1.845.419.419,0,0,0-.089.02.337.337,0,0,0-.064.028.5.5,0,0,0-.121.08l.007.008a3.556,3.556,0,0,0-.608,2.55,2.088,2.088,0,0,0,.056.2,1.412,1.412,0,0,0,1.166,1.008,1.53,1.53,0,0,0,.271.139,1.2,1.2,0,0,0,1.316-.173,3.2,3.2,0,0,0,.718-1.3l.013-.038a.5.5,0,0,0,.04-.3c0-.018-.007-.036-.012-.054a3.1,3.1,0,0,0,.76-.711.507.507,0,0,0,.14-.272,2.768,2.768,0,0,0,.882-.329.51.51,0,0,0,.223-.18,2.953,2.953,0,0,0,.94.043.506.506,0,0,0,.289-.081,3.82,3.82,0,0,0,.948.435.506.506,0,0,0,.337.03,5.026,5.026,0,0,0,.859.838l.046.037a.507.507,0,0,0,.754-.036A1.5,1.5,0,0,0,287.882,70.414Zm-3.728,9.93a.493.493,0,0,0,.119-.106,2.489,2.489,0,0,0,2.073-.166h0l.017-.015a.392.392,0,0,0,.033-.031.506.506,0,0,0,.113-.207,2.517,2.517,0,0,0,1.832-.977.514.514,0,0,0,.03-.08.487.487,0,0,0,.015-.229,2.857,2.857,0,0,0,1.413-1.683c0-.01,0-.021,0-.03a.5.5,0,0,0-.083-.33,3.631,3.631,0,0,0,.861-2.323h0v-.012a.237.237,0,0,0,0-.029.514.514,0,0,0-.126-.254,1.18,1.18,0,0,0-.523-.306,1.131,1.131,0,0,0-.955.1,1.5,1.5,0,0,0-1.173-.876.506.506,0,0,0-.623.425l-.015.058a5,5,0,0,0-.18,1.186.5.5,0,0,0-.264.256l0,0a3.689,3.689,0,0,0-.476.892.507.507,0,0,0-.447.35.477.477,0,0,1,.152-.233,2.9,2.9,0,0,0-.708.592.51.51,0,0,0-.321,0s.011-.006.016-.007a2.687,2.687,0,0,0-.884.266.506.506,0,0,0-.3-.134v0a3.023,3.023,0,0,0-1.012-.1.435.435,0,0,0-.023-.05.5.5,0,0,0-.211-.212l-.034-.023a3.206,3.206,0,0,0-1.359-.6,1.206,1.206,0,0,0-1.152.656,1.582,1.582,0,0,0-.132.274,1.41,1.41,0,0,0-.323,1.506,2.027,2.027,0,0,0,.076.193,3.558,3.558,0,0,0,2.023,1.67v.011a.483.483,0,0,0,.145-.009.321.321,0,0,0,.068-.017.464.464,0,0,0,.083-.037,2.819,2.819,0,0,0,2.129.7V80.4a.49.49,0,0,0,.08-.031A.3.3,0,0,0,284.154,80.344Zm1.613-4.281a.5.5,0,0,1,.009-.058.4.4,0,0,0-.008.058Zm-1.168.555a.573.573,0,0,1,.04-.083.467.467,0,0,0-.038.085Z",
    transform: "translate(-258.909 -51.114)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.269 15.966)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.064)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M284.777,69c.014,0-.448-.707-.042-1.238.421-.565,1.631-.417,1.622-.388A4.923,4.923,0,0,0,284.777,69Z",
    transform: "translate(-284.567 -67.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M286.235,68.56a3.654,3.654,0,0,1-1.351.462,4.923,4.923,0,0,1,1.579-1.626A1.18,1.18,0,0,1,286.235,68.56Z",
    transform: "translate(-284.674 -67.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M284.942,70.024a1.641,1.641,0,0,0,.606,1.076,2.172,2.172,0,0,0,1.156.156A5.412,5.412,0,0,0,284.942,70.024Z",
    transform: "translate(-284.694 -68.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M286.328,69.983a1.438,1.438,0,0,0-1.386-.044,5.412,5.412,0,0,1,1.762,1.232A1.475,1.475,0,0,0,286.328,69.983Z",
    transform: "translate(-284.694 -68.16)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.99 0.241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M287.531,68.933c.013.007-.264-.813.288-1.129.574-.345,1.771.289,1.755.316A4.157,4.157,0,0,0,287.531,68.933Z",
    transform: "translate(-287.474 -67.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M289.054,69.277a4.4,4.4,0,0,1-1.493-.131,4.157,4.157,0,0,1,2.044-.813C289.617,68.344,289.628,69.132,289.054,69.277Z",
    transform: "translate(-287.503 -67.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M287.565,69.74a1.65,1.65,0,0,0,.323,1.207,2.925,2.925,0,0,0,1.134.611A6.715,6.715,0,0,0,287.565,69.74Z",
    transform: "translate(-287.5 -68.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M288.965,70.335a1.769,1.769,0,0,0-1.393-.6,6.715,6.715,0,0,1,1.457,1.818A1.324,1.324,0,0,0,288.965,70.335Z",
    transform: "translate(-287.507 -68.386)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.742 1.137)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M290.359,69.94c.012.013-.051-.84.6-.884.683-.067,1.771,1.071,1.751,1.094A4.419,4.419,0,0,0,290.359,69.94Z",
    transform: "translate(-290.2 -69.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M291.878,71.144a6.9,6.9,0,0,1-1.519-.79,4.419,4.419,0,0,1,2.355.209A.721.721,0,0,1,291.878,71.144Z",
    transform: "translate(-290.2 -69.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M290.253,70.557a1.453,1.453,0,0,0,.005,1.218,4.425,4.425,0,0,0,1.021,1.07A7.907,7.907,0,0,0,290.253,70.557Z",
    transform: "translate(-290.12 -69.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M291.609,71.718a2.421,2.421,0,0,0-1.288-1.162,7.907,7.907,0,0,1,1.026,2.288A1.041,1.041,0,0,0,291.609,71.718Z",
    transform: "translate(-290.188 -69.56)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.296)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M279.347,75.213a.941.941,0,0,1-.873-.829,3.332,3.332,0,0,1,.448-2.071A9.824,9.824,0,0,0,279.347,75.213Z",
    transform: "translate(-278.432 -72.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M279.868,73.359a8.547,8.547,0,0,1-.272,1.854,9.825,9.825,0,0,1-.425-2.9A1.248,1.248,0,0,1,279.868,73.359Z",
    transform: "translate(-278.681 -72.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M279.958,76.171c0,.02.6.416,1,.048a3.4,3.4,0,0,0,.616-1.178A3.323,3.323,0,0,0,279.958,76.171Z",
    transform: "translate(-278.947 -73.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M280.592,74.39c-.53.248-.66,1.541-.635,1.543a3.323,3.323,0,0,1,1.618-1.129C281.572,74.82,281.091,74.144,280.592,74.39Z",
    transform: "translate(-278.945 -72.995)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.912 1.416)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M280.457,72.134a1.166,1.166,0,0,1-.648-1.08,2.431,2.431,0,0,1,.962-1.579A7.977,7.977,0,0,0,280.457,72.134Z",
    transform: "translate(-279.808 -69.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M281.518,70.682a5.5,5.5,0,0,1-.735,1.453,7.977,7.977,0,0,1,.314-2.659A1.389,1.389,0,0,1,281.518,70.682Z",
    transform: "translate(-280.134 -69.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M280.916,73.453c0,.016.484.615.971.489.468-.123.885-.746.9-.741A3.378,3.378,0,0,0,280.916,73.453Z",
    transform: "translate(-280.182 -70.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M281.928,72.048c-.584,0-1.037,1.021-1.012,1.029a3.378,3.378,0,0,1,1.873-.252C282.782,72.837,282.481,72.045,281.928,72.048Z",
    transform: "translate(-280.182 -70.343)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.315 0.309)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M282.342,70.044a1.264,1.264,0,0,1-.363-1.219c.234-.73,1.357-1.051,1.355-1.019A6.3,6.3,0,0,0,282.342,70.044Z",
    transform: "translate(-281.927 -67.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M283.648,69.055a4.019,4.019,0,0,1-1.095.99,6.3,6.3,0,0,1,.992-2.238A1.358,1.358,0,0,1,283.648,69.055Z",
    transform: "translate(-282.138 -67.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M282.65,71.336c-.008.012.32.742.831.834a1.954,1.954,0,0,0,1.08-.3A4.192,4.192,0,0,0,282.65,71.336Z",
    transform: "translate(-282.171 -68.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M283.91,70.559c-.577-.231-1.283.486-1.261.5a4.192,4.192,0,0,1,1.911.538C284.551,71.6,284.458,70.776,283.91,70.559Z",
    transform: "translate(-282.171 -68.718)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.74 6.204)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.458 2.829)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M289.706,84.234c.01-.009.068.834.712,1.014.677.2,1.553-.651,1.528-.668A4.933,4.933,0,0,1,289.706,84.234Z",
    transform: "translate(-289.435 -82.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M291.062,83.562a3.65,3.65,0,0,0-1.356.445,4.933,4.933,0,0,0,2.24.345C291.953,84.34,291.657,83.586,291.062,83.562Z",
    transform: "translate(-289.435 -81.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M289.529,83.018a1.641,1.641,0,0,1-.165-1.224,2.167,2.167,0,0,1,.829-.821A5.417,5.417,0,0,1,289.529,83.018Z",
    transform: "translate(-289.296 -80.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M290.727,82.148c-.152.657-1.084.9-1.08.87a5.417,5.417,0,0,0,.664-2.045A1.476,1.476,0,0,1,290.727,82.148Z",
    transform: "translate(-289.415 -80.973)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.719 1.645)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M292.016,82.554c.007-.013.28.808.911.727.666-.07,1.238-1.3,1.21-1.31A4.164,4.164,0,0,1,292.016,82.554Z",
    transform: "translate(-291.475 -80.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M293.129,81.309a4.415,4.415,0,0,0-1.113,1,4.164,4.164,0,0,0,2.121-.582C294.14,81.715,293.674,81.08,293.129,81.309Z",
    transform: "translate(-291.475 -79.886)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M291.675,81.515a1.652,1.652,0,0,1-.47-1.158,2.927,2.927,0,0,1,.537-1.171A6.726,6.726,0,0,1,291.675,81.515Z",
    transform: "translate(-291.2 -79.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M292.668,80.2a1.769,1.769,0,0,1-.751,1.317,6.726,6.726,0,0,0,.066-2.329A1.327,1.327,0,0,1,292.668,80.2Z",
    transform: "translate(-291.442 -79.186)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.57)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M293.748,79.694c0-.018.466.7,1.015.341.585-.358.768-1.922.739-1.928A4.423,4.423,0,0,1,293.748,79.694Z",
    transform: "translate(-292.911 -77.177)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M294.484,78.044a6.874,6.874,0,0,0-.736,1.547A4.423,4.423,0,0,0,295.5,78,.721.721,0,0,0,294.484,78.044Z",
    transform: "translate(-292.911 -77.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M293.236,79.147a1.447,1.447,0,0,1-.73-.974,4.4,4.4,0,0,1,.17-1.469A7.965,7.965,0,0,1,293.236,79.147Z",
    transform: "translate(-292.485 -76.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M293.661,77.444a2.42,2.42,0,0,1-.327,1.7,7.966,7.966,0,0,0-.56-2.444A1.041,1.041,0,0,1,293.661,77.444Z",
    transform: "translate(-292.582 -76.703)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.664)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M281.375,81.831a.941.941,0,0,0-.2,1.188,3.333,3.333,0,0,0,1.606,1.383A9.806,9.806,0,0,1,281.375,81.831Z",
    transform: "translate(-281.058 -81.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M282.871,83.147a8.6,8.6,0,0,0-1.334-1.316,9.806,9.806,0,0,0,1.408,2.571A1.25,1.25,0,0,0,282.871,83.147Z",
    transform: "translate(-281.22 -81.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M281.618,81.37c-.011-.016.229-.693.771-.643a3.387,3.387,0,0,1,1.2.569A3.321,3.321,0,0,1,281.618,81.37Z",
    transform: "translate(-281.247 -80.725)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M283.055,82.51c-.572.121-1.456-.832-1.437-.849a3.321,3.321,0,0,0,1.972-.074C283.578,81.576,283.6,82.405,283.055,82.51Z",
    transform: "translate(-281.247 -81.016)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.984 3.546)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M284.179,83.8a1.164,1.164,0,0,0,.133,1.252,2.428,2.428,0,0,0,1.72.68A7.969,7.969,0,0,1,284.179,83.8Z",
    transform: "translate(-284.053 -82.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M285.705,84.515a5.52,5.52,0,0,0-1.461-.717A7.968,7.968,0,0,0,286.1,85.73,1.388,1.388,0,0,0,285.705,84.515Z",
    transform: "translate(-284.117 -82.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M284.278,83.1c-.013-.01.016-.782.48-.975a2.275,2.275,0,0,1,1.167.048A3.373,3.373,0,0,1,284.278,83.1Z",
    transform: "translate(-284.128 -82.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M285.706,83.37c-.464.354-1.443-.19-1.428-.211a3.373,3.373,0,0,0,1.647-.927C285.912,82.226,286.15,83.039,285.706,83.37Z",
    transform: "translate(-284.129 -82.116)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.898 3.514)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M287.035,84.574a1.266,1.266,0,0,0,.445,1.191,1.983,1.983,0,0,0,1.7,0A6.289,6.289,0,0,1,287.035,84.574Z",
    transform: "translate(-286.969 -82.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M288.512,84.695a4.009,4.009,0,0,0-1.471-.129,6.289,6.289,0,0,0,2.14,1.187A1.358,1.358,0,0,0,288.512,84.695Z",
    transform: "translate(-286.975 -82.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M287,83.589a1.445,1.445,0,0,1,.16-1.167,1.953,1.953,0,0,1,1.041-.415A4.205,4.205,0,0,1,287,83.589Z",
    transform: "translate(-286.942 -82.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M288.335,83.228c-.321.533-1.317.386-1.307.362a4.2,4.2,0,0,0,1.2-1.581C288.216,82.007,288.641,82.725,288.335,83.228Z",
    transform: "translate(-286.971 -82.008)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 27.001,
    height: 4.478,
    transform: "translate(12.725 16.632) rotate(71.468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 33.757,
    height: 9.909,
    transform: "translate(10.729 49.341) rotate(-108.532)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 22.513,
    height: 5.399,
    transform: "translate(11.467 43.165) rotate(-108.532)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M262.352,195.018a8.664,8.664,0,0,1-5.065-3.182l-4.3,6.053-3.975-16.781c-1.184-4.734-6.36-8.485-11.357-11.09-11.193,3.334-10.824-6.842-10.614-8.838-2.171-13.092,7.422-24.227,15.808-34.7l-9.4-3.225c-35.707,32.593-39.007,86.757-39.007,86.757l43.307,6.425c-6.729-8.059.889-12.475-2.966-12.924-.817-.095,1.17-1.685,1.316-2.422.138-.7-.694-1.271-.494-1.893a16.554,16.554,0,0,1,4.8-7.491c.248,20.937,13.469,25.614,13.469,25.614Z",
    transform: "translate(-190.178 -70.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M243.709,202.351a.8.8,0,0,0-1.039.374c-.107.35.184.749.65.892a.8.8,0,0,0,1.039-.374C244.466,202.894,244.175,202.495,243.709,202.351Zm-2.041,5.53c.107-.35-.184-.749-.65-.893a.8.8,0,0,0-1.039.374c-.108.35.184.749.649.892A.8.8,0,0,0,241.668,207.881Zm-.431,5.785c-.488,0-.883.3-.883.662s.4.662.883.662.883-.3.883-.662S241.725,213.666,241.237,213.666ZM240.593,219a.92.92,0,1,0,.942.576A.8.8,0,0,0,240.593,219Zm-4.062,4.387a.69.69,0,1,0,.434,1.016A.8.8,0,0,0,236.531,223.388Z",
    transform: "translate(-203.994 -96.93)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.878 101.101)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M236.289,227.572l-.16-.643c1.405-.352,1.491-3.335,1.406-4.456l-.009-.127,1.783-2.319.074-.034c.04-.018,3.962-1.818,4.923-2.458.219-.252-.393-1.958-.839-3.2-.765-2.134-1.718-4.789-1.627-6.968a7.981,7.981,0,0,1,3.389-6.067l-1.025-2.222.339-.123a12.047,12.047,0,0,0,2.556-1.273.269.269,0,0,0,.127-.228c0-.349-.53-.874-.786-1.073l.407-.523c.106.083,1.035.827,1.041,1.591a.935.935,0,0,1-.375.751,10.923,10.923,0,0,1-2.407,1.249l.97,2.1-.254.153a7.482,7.482,0,0,0-3.318,5.692c-.085,2.05.843,4.638,1.589,6.717.788,2.2,1.264,3.524.583,3.978-.94.627-4.371,2.214-4.939,2.476l-1.53,1.989C238.244,223.314,238.338,227.06,236.289,227.572Z",
    transform: "translate(-236.129 -195.855)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.606 59.238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M281.647,227.542l-8.612,16.23c-8.943-12.089-8.446-23.516-8.446-23.516-3.975,19.376,12.421,28.982,12.421,28.982l7.121-19.542Z",
    transform: "translate(-221.255 -162.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M199.489,245.127c.221,2.65,2.871-1.1,2.871-1.1s.441-10.82.221-12.144S199.489,245.127,199.489,245.127Z",
    transform: "translate(-199.489 -166.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M241.434,206.364c-.264-2.372-45.266-23.958.994-67.237,0,0-10.68,3.437-10.488.883a15.276,15.276,0,0,1,2.506-7.35c-7.5,8.237-22.029,31.857-17.908,51.567,4.582,21.916,17.941,22.247,17.941,22.247a18.948,18.948,0,0,1-11.813-15.567S227.082,201.506,241.434,206.364Z",
    transform: "translate(-205 -132.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M243.344,192.9c.66.224-2.2-2.277-2.567-3.561a3.929,3.929,0,0,1,.18-2.713,12.183,12.183,0,0,1-.735-4.73c-1.577,1.736-6.566,7.613-6.566,12.494,0,0,2.9-8.2,5.879-8.86C239.535,185.528,238.21,191.159,243.344,192.9Z",
    transform: "translate(-211.023 -149.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M255.577,217.976c-4.968,6.956-12.421,1.987-12.421,1.987l8.115,9.605s2.153-6.459,5.465-9.44l2.484-6.624S256.618,216.519,255.577,217.976Z",
    transform: "translate(-214.229 -159.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M274.312,235.908l4.637-2.153-6.293,1.49,1.325,6.128Z",
    transform: "translate(-224.188 -166.786)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M252.228,192.452l.414-.828,2.236-.994,2.774,1.035,1.781,2.65s-5.01.124-6.376-.539S252.228,192.452,252.228,192.452Z",
    transform: "translate(-209.65 -92.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M250.156,192.682l3.754-1.987,1.38,5.244,4.885-1.49-.248-3.809-5.907-.718Z",
    transform: "translate(-208.986 -92.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M254.028,194.005s10.93,12.835,23.268,5.382c0,0-5.051,6.707-10.93,5.465s-11.924-6.956-12.835-10.1Z",
    transform: "translate(-210.126 -94.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M252.323,189.953s8.17,24.731,30.03,4.637c0,0,1.536-2.356,1.255-9.336a.489.489,0,0,0-.739-.4l-6.7,4S273.4,204.2,262.7,200.11C255.193,197.24,252.323,189.953,252.323,189.953Z",
    transform: "translate(-209.718 -91.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M248.406,192.3s1.987-1.546,3.092-.884a7.108,7.108,0,0,1,1.932,1.932l-1.325,1.27A4.97,4.97,0,0,1,248.406,192.3Z",
    transform: "translate(-208.396 -93.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M246.63,188.089a4.28,4.28,0,0,0,2.208,3.478s1.711.938.773,1.1-2.429-.938-3.092-2.7S246.63,188.089,246.63,188.089Z",
    transform: "translate(-207.668 -92.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M246.673,188.863l2.043-3.753-4.416-5.355-.662.331S243.029,187.1,246.673,188.863Z",
    transform: "translate(-206.773 -89.319)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.631 34.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M252.489,113.627l9.4,3.225,0,0a138.424,138.424,0,0,1,9.717-10.884l4.039-.623,1.545-1.794,1.132.028s.678-.533.524-.994c-.5-1.49-1.512-.955-1.9-1.739-.735-1.47-1.543-3.115-1.822-3.782-.43-1.032-.4-2.491-1.877-2.319-8.446.994-4.968,6.624-7.047,8.56a89.77,89.77,0,0,0-15.345,11.849Q251.659,114.385,252.489,113.627Z",
    transform: "translate(-250.853 -94.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M295.583,206.255h-9.108l-2.319,2.981s.166,1.822,1.656,2.153c.669.149,1.036-.3,1.239-.847.295,2.026,2.552,4.577,3.31,5.386l-2.789,3.926a8.664,8.664,0,0,0,5.065,3.182l2.448-6.438C296.742,212.7,295.583,206.255,295.583,206.255Z",
    transform: "translate(-262.095 -132.379)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M192.08,246.932s12.586-12.366,43.015-1.2l-1.282,3.4s28.937,13.28,36.326,35.974l-40.907,16.606,3.871,11.887s-1.634,2.325-4.844-1.112-8.872-16.235-8.872-16.235L250.6,278.328s-16.473-14.805-34.606-10.843c0,0-19.433,29.335-11.616,68.024,0,0,.767,18.873-4.618,17.937s-2.212-17.806-2.212-17.806S180.4,298.244,192.08,246.932Z",
    transform: "translate(-188.007 -110.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M253.564,116.71s5.079-6.183,9.937,4.858l-4.2,6.183s-4.637-7.728-11.482-5.52Z",
    transform: "translate(-208.199 -67.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M285.82,225.422s3.6,4.085,7.6,3.643l-3.4,9.274s-5.8.111-8.194-8.28Z",
    transform: "translate(-219.676 -104.735)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M225.727,397.852a164.39,164.39,0,0,1-5.684-17.308c-1.6-5.865-2.876-11.815-3.924-17.8l-.695-4.509-.54-4.529c-.2-1.508-.311-3.025-.422-4.542s-.272-3.029-.286-4.552a111.93,111.93,0,0,1,.707-18.2l-.275,4.544c-.036.757-.122,1.512-.118,2.27l-.007,2.275-.02,2.273c-.007.757-.025,1.514.024,2.271l.2,4.541a166.454,166.454,0,0,0,2.087,18.047c.99,5.978,2.272,11.907,3.761,17.784.75,2.937,1.547,5.864,2.421,8.768C223.792,392.1,224.733,394.983,225.727,397.852Z",
    transform: "translate(-196.805 -138.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M230.651,401.433c-1.07-2.306-1.975-4.684-2.81-7.085s-1.545-4.845-2.219-7.3c-.629-2.464-1.2-4.946-1.636-7.451a69.92,69.92,0,0,1-.933-7.566c.252,1.247.406,2.5.682,3.744l.35,1.867.4,1.857c.539,2.473,1.1,4.941,1.776,7.381.618,2.454,1.329,4.884,2.061,7.309q.546,1.819,1.137,3.627C229.836,399.03,230.246,400.229,230.651,401.433Z",
    transform: "translate(-199.837 -154.226)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(69.543 165.469)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M307.113,293.024c1.375,2.187,2.66,4.421,3.935,6.659q1.888,3.371,3.7,6.783l.315.594-.623.28c-1.762.793-3.517,1.6-5.292,2.366-1.767.782-3.547,1.536-5.329,2.282-3.573,1.475-7.16,2.92-10.826,4.187,3.4-1.873,6.873-3.567,10.362-5.231,1.749-.823,3.5-1.64,5.265-2.427,1.756-.806,3.533-1.565,5.3-2.342l-.308.874q-1.724-3.455-3.368-6.951C309.161,297.76,308.092,295.415,307.113,293.024Z",
    transform: "translate(-292.987 -293.024)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.388 19.937)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M157.592,40.4c-1.568-1.562-2.778-2.905-2.843-5.225-.056-2.006.448-3.991.484-6a.994.994,0,0,0-1.987,0c-.047,2.593-.891,5.29-.276,7.866.472,1.977,1.819,3.368,3.217,4.76A.994.994,0,0,0,157.592,40.4Z",
    transform: "translate(-81.836 -27.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M166.628,98.927c-.262.678-1.218,1.221-1.787,1.6-.707.474-1.446.895-2.173,1.336a.994.994,0,0,0,1,1.716c1.725-1.047,4.1-2.126,4.873-4.127C169.007,98.262,167.086,97.745,166.628,98.927Z",
    transform: "translate(-85.026 -50.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M111.177,85.049a3.007,3.007,0,0,0-.672,3.313c.67,1.252,1.669,1.094,2.778,1.173-.109,1.029-.865,2.113-.973,3.107a2.791,2.791,0,0,0,.82,2.423c.88.931,2.284-.476,1.405-1.405-.745-.788.282-2.344.518-3.145a4.145,4.145,0,0,0,.133-2.113.972.972,0,0,0-.694-.694c-.9-.192-2.548.219-1.891-1.241.38-.844,2.275-2.413,3.178-1.559.929.878,2.337-.525,1.405-1.406C115.17,81.6,112.623,83.214,111.177,85.049Z",
    transform: "translate(-67.486 -45.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M348.934,48.552l.424.131a.914.914,0,0,0,.607-.032c.046.024.089.046.1.054q.147.1.038.027a1.829,1.829,0,0,1,.14.137.994.994,0,1,0,1.405-1.406,2.743,2.743,0,0,0-2.715-.828A1,1,0,0,0,348.934,48.552Z",
    transform: "translate(-147.824 -33.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M349.975,87.329a27.217,27.217,0,0,1-4.655,1.663,11.189,11.189,0,0,1,4.36-2.874,1,1,0,0,0-.529-1.916c-1.589.4-2.7,1.485-3.979,2.442a7.838,7.838,0,0,0-2.673,2.8,1.007,1.007,0,0,0,.594,1.459,8.6,8.6,0,0,0,5.015-.712,11.248,11.248,0,0,0-1.481,1.684,7.773,7.773,0,0,0-1.3,3.88c.05,1.275,2.038,1.281,1.987,0-.126-3.2,3.968-4.538,3.915-7.473A1,1,0,0,0,349.975,87.329Z",
    transform: "translate(-145.85 -46.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M375.487,142.035v-4.858a.994.994,0,0,0-1.987,0v4.858A.994.994,0,0,0,375.487,142.035Z",
    transform: "translate(-156.355 -63.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M385.382,169.5a2.069,2.069,0,0,0-1.586.733,1.023,1.023,0,0,0,0,1.405,1,1,0,0,0,1.406,0,1.273,1.273,0,0,1,.125-.142l0,0,.015,0h.037a.994.994,0,0,0,0-1.987Z",
    transform: "translate(-159.736 -75.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M103.673,190.69a2.175,2.175,0,0,0-1.108-1.08,7.161,7.161,0,0,0-1.74-.391,13.762,13.762,0,0,0-2.314-.385.994.994,0,0,0,0,1.987,18.531,18.531,0,0,1,2.344.4c.536.082,1.2.053,1.089.757-.127.847.96,1.839,1.661.967a9.428,9.428,0,0,0,.621-.853A.927.927,0,0,0,103.673,190.69Z",
    transform: "translate(-63.205 -81.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M158.678,156.46l-.884.883a.994.994,0,0,0,1.406,1.406l.883-.884a.994.994,0,0,0-1.405-1.405Z",
    transform: "translate(-83.444 -70.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M423.131,43.519c-2.159.81-4.664,2.172-5.38,4.563-.7,2.334,1.739,3.552,3.613,3.977,1.245.283,1.777-1.632.528-1.916a4.968,4.968,0,0,1-1.72-.617c-.746-.511-.541-1-.07-1.681a7.218,7.218,0,0,1,3.557-2.411C424.846,44.99,424.332,43.068,423.131,43.519Z",
    transform: "translate(-171.251 -32.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M432.777,79.639a1,1,0,0,0-1.359.356q-.222.441-.442.883a1.018,1.018,0,0,0,.356,1.359,1,1,0,0,0,1.359-.356q.222-.441.442-.883A1.018,1.018,0,0,0,432.777,79.639Z",
    transform: "translate(-175.716 -44.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M420.511,169.5a.994.994,0,0,0,0,1.987A.994.994,0,0,0,420.511,169.5Z",
    transform: "translate(-171.9 -75.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M405.512,231.569c-.147.827-.191,1.669-.309,2.5a4.029,4.029,0,0,1-.76,2.36c-.958.851.452,2.252,1.405,1.405,1.507-1.339,1.259-3.934,1.581-5.738C407.651,230.846,405.736,230.31,405.512,231.569Z",
    transform: "translate(-166.692 -95.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M348.211,216.7c.009.006.021.008.03.014a.2.2,0,0,0-.021-.019l-.007,0Z",
    transform: "translate(-147.818 -90.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M348.23,215.543c-.3-.083-.61-.2-.916-.266a.513.513,0,0,1-.153-.072c.156.155-.461.142-.03-.014a1.1,1.1,0,0,0-.173-.1.811.811,0,0,1,.182.1,8.546,8.546,0,0,0,.878-.639,9.307,9.307,0,0,1,1.02-.507c1.173-.5.162-2.213-1-1.716-1.333.568-3.844,2.011-2.759,3.8a3.377,3.377,0,0,0,2.131,1.251c.725.2,1.577.2,1.461,1.1-.162,1.265,1.826,1.253,1.987,0C351.082,216.722,349.706,215.95,348.23,215.543Z",
    transform: "translate(-146.738 -89.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M137.567,265.8c-.537.494-1.73.166-2.389.151a.994.994,0,0,0,0,1.987c1.349.03,2.707.266,3.794-.733C139.915,266.339,138.507,264.936,137.567,265.8Z",
    transform: "translate(-75.582 -107.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M209.565,136.2a.985.985,0,0,0,.432,1.92l.032.015-.028-.015h0l.076.037a1.909,1.909,0,0,1,.414.282c.287.242.55.51.841.747a1.022,1.022,0,0,0,1.405,0,1,1,0,0,0,0-1.405C211.793,137.008,210.928,135.917,209.565,136.2Z",
    transform: "translate(-100.771 -63.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M225.6,27.64a1,1,0,0,0-.958-.729,4.342,4.342,0,0,0-2.644.966,1.024,1.024,0,0,0-.356,1.359,1,1,0,0,0,1.359.356,4.513,4.513,0,0,1,.9-.53c.047-.02.081-.026.124-.042a1.082,1.082,0,0,0,.947.231,1.017,1.017,0,0,0,.694-1.222Z",
    transform: "translate(-105.046 -26.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M54.953,44.04c-1.245-.044-2.384.474-3.639.459a8.541,8.541,0,0,1-4.1-.592c-.963-.511-2.063.764-1.2,1.561l.289.268A.947.947,0,0,0,47.07,46a9.252,9.252,0,0,0,3.15.466,16.761,16.761,0,0,0,2.474-.036,12.954,12.954,0,0,1,2.259-.4C56.232,46.071,56.23,44.084,54.953,44.04Z",
    transform: "translate(-45.702 -32.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M51.291,142.95c-1.573,1.07-3.652,1.808-4.431,3.685a1,1,0,0,0,.694,1.222,1.018,1.018,0,0,0,1.222-.694c.24-.58,1.093-1.018,1.591-1.329.637-.4,1.306-.747,1.926-1.169C53.346,143.951,52.352,142.228,51.291,142.95Z",
    transform: "translate(-46.075 -66.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M68.958,250.409c-1.306-.178-2.434-1.082-3.8-.919a1.026,1.026,0,0,0-.994.994,1,1,0,0,0,.994.994c1.135-.136,2.16.7,3.268.848a1.03,1.03,0,0,0,1.222-.694A1,1,0,0,0,68.958,250.409Z",
    transform: "translate(-51.935 -102.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M376.026,292.162c-1.451.194-2.207,1.3-3.158,2.293a8.982,8.982,0,0,0-2.106,3.083c-1.065.35-.531,2.1.67,1.875l.359-.067a.98.98,0,0,0,.694-.694,5.819,5.819,0,0,1,1.6-2.6c.453-.467,1.26-1.808,1.939-1.9C377.275,293.982,377.291,291.992,376.026,292.162Z",
    transform: "translate(-155.238 -116.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M384.765,341.193,383,340.309a1.019,1.019,0,0,0-1.359.356,1,1,0,0,0,.356,1.36l1.767.883a1.018,1.018,0,0,0,1.359-.356A1,1,0,0,0,384.765,341.193Z",
    transform: "translate(-159.059 -132.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M422.083,283.333a29.3,29.3,0,0,1-2.936,3.774c-.817.974.582,2.386,1.405,1.405a32.433,32.433,0,0,0,3.247-4.176A.994.994,0,0,0,422.083,283.333Z",
    transform: "translate(-171.68 -113.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M456.875,153.791c-1.044,1.035-.743,2.476-.733,3.794a.994.994,0,0,0,1.987,0c-.005-.639-.354-1.889.15-2.389A.994.994,0,0,0,456.875,153.791Z",
    transform: "translate(-184.236 -69.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M66.485,335.5H62.511a.994.994,0,0,0,0,1.987h3.975A.994.994,0,0,0,66.485,335.5Z",
    transform: "translate(-51.052 -131.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M112.819,330.511c.015,3.42.659,7.011-1.189,10.1a.994.994,0,0,0,1.716,1c2.058-3.436,1.478-7.279,1.461-11.1A.994.994,0,0,0,112.819,330.511Z",
    transform: "translate(-67.907 -129.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M108.511,381.5a.994.994,0,0,0,0,1.987A.994.994,0,0,0,108.511,381.5Z",
    transform: "translate(-66.58 -146.604)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotconfirm);
export default __webpack_public_path__ + "static/media/forgotconfirm.f11fb4ddab79b55c138ff5b31fcc4e9f.svg";
export { ForwardRef as ReactComponent };